import {IUserProfile} from "../../user/types/IUserProfile";
import {checkHasCompleteProfile} from "../../user/utils/check_has_complete_profile";
import {checkHasName} from "../../user/utils/check_has_name";
import {checkHasPhone} from "../../user/utils/check_has_phone";
import {checkHasVerifiedPhone} from "../../user/utils/check_has_verified_phone";

export const getRegistrationFlowUserState = (userProfile: IUserProfile | null | undefined) => ({
    isUserLoggedIn: Boolean(userProfile),
    hasCompleteProfile: checkHasCompleteProfile(userProfile),
    hasPhoneVerified: checkHasVerifiedPhone(userProfile),
    hasPhone: checkHasPhone(userProfile),
    hasName: checkHasName(userProfile)
});
import {IUserProfile} from "../../user/types/IUserProfile";
import {checkHasCompleteProfile} from "../../user/utils/check_has_complete_profile";
import {checkHasName} from "../../user/utils/check_has_name";
import {checkHasPhone} from "../../user/utils/check_has_phone";
import {checkHasVerifiedPhone} from "../../user/utils/check_has_verified_phone";

export const getRegistrationFlowUserState = (userProfile: IUserProfile | null | undefined) => ({
    isUserLoggedIn: Boolean(userProfile),
    hasCompleteProfile: checkHasCompleteProfile(userProfile),
    hasPhoneVerified: checkHasVerifiedPhone(userProfile),
    hasPhone: checkHasPhone(userProfile),
    hasName: checkHasName(userProfile)
});
